import { render, staticRenderFns } from "./ProductServiceCategoryEdit.vue?vue&type=template&id=03c5d294&"
import script from "./ProductServiceCategoryEdit.js?vue&type=script&lang=js&"
export * from "./ProductServiceCategoryEdit.js?vue&type=script&lang=js&"
import style0 from "./ProductServiceCategoryEdit.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports